import * as React from 'react';
import styled from 'styled-components';
import Typography from '@components/basics/typography';

export const NavbarActionsOnboardingCtrl = () => {
  return (
    <Typography className="status" type="link" opacity=".7">
      Progress Saved
    </Typography>
  );
};

export default styled(NavbarActionsOnboardingCtrl)`
  display: flex;
  align-items: center;
`;
